import { render, staticRenderFns } from "./category_marketplace_page.vue?vue&type=template&id=c02afc0e&scoped=true"
import script from "./category_marketplace_page.vue?vue&type=script&lang=js"
export * from "./category_marketplace_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c02afc0e",
  null
  
)

export default component.exports